import axios from 'axios';
import GET_EDUCATIONS from './const';

export default () => {
  const request = axios.get('https://auwebtools.azurewebsites.net/api/Evu/GetList');

  return {
    type: GET_EDUCATIONS,
    payload: request,
  };
};
